import axios from "axios";
// import Resizer from "react-image-file-resizer";

import { ApiConfig } from "../../configuration";
import { ObservationImages, DB, Constant } from "../../constants";
import { ApiService } from "../../services";
import { Md5, DateGenerator, aesUtil } from "..";

// const getHeightAndWidthFromDataUrl = dataURL => new Promise(resolve => {
//     const img = new Image()
//     img.onload = () => {
//         resolve({
//             height: img.height,
//             width: img.width
//         })
//     }
//     img.src = dataURL
// })

// const resizeFile = (file, width, height) => new Promise(resolve => {
//     let maxWidth = 0
//     let maxHeight = 0
//     if (width > height) {
//         maxWidth = 306
//         maxHeight = 180
//     }
//     else {
//         maxWidth = 180
//         maxHeight = 306
//     }
//     const type = file.type.split("/")[1]
//     Resizer.imageFileResizer(file, maxWidth, maxHeight, type.toUpperCase(), 60, 0,
//         uri => {
//             resolve(uri);
//         }, 'file');
// });

const getImageDimensions = (image) => {
    return new Promise((resolve, reject) => {
        image.onload = function(e){
            const width = this.width;
            const height = this.height;
            resolve({height, width});
        }
    });
}

const compressImage = (image, imageFileName, imageType, scale, initalWidth, initalHeight) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");

      canvas.width = scale * initalWidth;
      canvas.height = scale * initalHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      
      ctx.canvas.toBlob((blob) => { 
          const resizedFile = new File([blob], imageFileName, {type: imageType});
          resolve(resizedFile);
      }, imageType);

    })
}

const generatedRandomNumber = () => {
    const crypto = window.crypto || window.msCrypto
    var array = new Uint32Array(1)
    return crypto?.getRandomValues(array)[0]
}

const submitForm = async (formData, isSaved) => {
    let currentMaterialId = formData.get("materiel-id")
    let currentExploitantId = formData.get("exploitant-id")
    try {
        // if new material and exploitant create offline
        if (currentExploitantId.includes("PWA")) {
            formData.set("exploitant-id", "")
        }
        if (currentMaterialId.includes("PWA")) {
            formData.set("materiel-id", "")
        }

        /* Submit Form */
        const res = await axios({
            url: `${ApiConfig.baseUrlApi}ws_saveform.php?key=${ApiConfig.key}&user=${Md5.hash(localStorage.getItem(Constant.localStorageKey.userId))}&app=${Md5.hash(ApiConfig.appId)}&adlog=ok`,
            method: "POST",
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        if (!res.data.controle_id) {
            throw new Error("error")
        }

        /* Upload Image */
        const id_controle = res.data.controle_id
        const imageCount = await uploadImage(id_controle)
        if (imageCount > 0) {
            throw new Error("error");
        }

        /* Rewrite PDF */
        const rewriteRes = await ApiService.get(`ws_rewritepdf.php?id_controle=${id_controle}`)
        if (rewriteRes.status !== 200) {
            throw new Error("error")
        }
        const { url_controle } = rewriteRes.data

        // cache PDF data
        await filterPdfData()
        const pdfData = await updatePdf(url_controle)

        await DB.submitFormData.add({
            data: id_controle,
            userId: parseInt(localStorage.getItem(Constant.localStorageKey.userId)),
            pdfUrl: url_controle
        });

        const id_exploitant = res.data.id_exploitant
        const id_materiel = res.data.id_materiel
        return { success: true, id_controle, id_exploitant, id_materiel }
    } catch (e) {
        console.log(e)
        if (e.code === "ERR_NETWORK") {
            // if need to save when no internet
            if (isSaved) {
                if (currentMaterialId === "") {
                    currentMaterialId = "PWA Material " + generatedRandomNumber()
                }
                formData.set("materiel-id", currentMaterialId)

                if (currentExploitantId === "") {
                    currentExploitantId = "PWA Exploitant " + generatedRandomNumber()
                }
                formData.set("exploitant-id", currentExploitantId)

                localStorage.setItem(Constant.localStorageKey.attempToSaveForm, true)
                let formDataToSave = Object.fromEntries(formData.entries());
                const observationImages = [...ObservationImages.getImage()]

                await DB.saveFormData.add({
                    data: formDataToSave,
                    userId: parseInt(localStorage.getItem(Constant.localStorageKey.userId)),
                    images: observationImages,
                    date: DateGenerator.generateDate()
                });

                return { success: false, id_controle: null, id_exploitant: currentExploitantId, id_materiel: currentMaterialId }
            }
        }

        throw new Error("error")
    }
}

const uploadImage = async (id_controle) => {
    const observationImages = ObservationImages.getImage()
    let imageCount = observationImages.length
    for (let image of observationImages) {
        const requestData = new FormData()
        // if (image.image.size <= 51200) { // if less then 50KB no need to resize
        //     requestData.append("file", image.image)
        // }
        // else {
        //     const fileAsDataURL = window.URL.createObjectURL(image.image)
        //     const dim = await getHeightAndWidthFromDataUrl(fileAsDataURL)
        //     const resizeImage = await resizeFile(image.image, dim.width, dim.height)
        //     requestData.append("file", resizeImage)
        // }

        // Compress image with Canvas
        if (image.image.size <= 51200) { // if less then 50KB no need to resize
            requestData.append("file", image.image);
        } else {
            const inputImage = new Image();
            inputImage.src = window.URL.createObjectURL(image.image);
            const {height, width} = await getImageDimensions(inputImage);
            const MAX_WIDTH = 500;
            const MAX_HEIGHT = 500;

            const widthRatioBlob = await compressImage(inputImage, image.image.name, image.image.type, MAX_WIDTH / width, width, height); 
            const heightRatioBlob = await compressImage(inputImage, image.image.name, image.image.type, MAX_HEIGHT / height, width, height);

            const compressedFile = widthRatioBlob.size > heightRatioBlob.size ? heightRatioBlob : widthRatioBlob;

            requestData.append("file", compressedFile);
        }

        const uploadRes = await axios({
            url: `${ApiConfig.baseUrlApi}ws_savephoto.php?key=${ApiConfig.key}&user=${Md5.hash(localStorage.getItem(Constant.localStorageKey.userId))}&app=${Md5.hash(ApiConfig.appId)}&id_controle=${id_controle}&id_question=${image.questionId}&nb_photos=1`,
            method: "POST",
            data: requestData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        console.log(`${ApiConfig.baseUrlApi}ws_savephoto.php?key=${ApiConfig.key}&user=${Md5.hash(localStorage.getItem(Constant.localStorageKey.userId))}&app=${Md5.hash(ApiConfig.appId)}&id_controle=${id_controle}&id_question=${image.questionId}&nb_photos=1`);

        if (uploadRes.status !== 200) {
            return;
        }

        imageCount -= 1;
    }

    return imageCount
}

const updatePdf = async (url_controle) => {
    try{
        const pdfRes = await axios({
            url: `https:${url_controle}`,
            method: "GET",
            responseType: 'blob'
        });
        return pdfRes.data
    } catch(e) {
        return null;
    }
}

const filterPdfData = async () => {
    const formData = await DB.submitFormData.toArray()
    const totalEntry = formData.length
    if(totalEntry > 20){
        const differences = totalEntry - 20
        for(let i = 0; i < differences; i++){
            const id = formData[i].id
            const id_controle = formData[i].data
            
            await DB.submitFormData.delete(id)
        }
    }
}

const loginUser = async (username, password) => {
    try {
        await DateGenerator.getServerDate();
        const res = await axios.get(`${ApiConfig.baseUrlApi}ws_getuserinfos.php?key=${ApiConfig.key}&login=${Md5.hash(username)}&pass=${Md5.hash(password)}&app=${Md5.hash(ApiConfig.appId)}`)
        if (res.data === null) {
            return { isSucess: false, message: "Votre compte n'est pas enregistré sur notre système." }
        }

        if (res.status === 200 && res.data !== false) {
            localStorage.setItem(Constant.localStorageKey.isLoggedIn, true);
            localStorage.setItem(Constant.localStorageKey.userId, res.data.personnel_controleur.id);
            localStorage.setItem(Constant.localStorageKey.updateDone, true)

            const usersDataQuery = await DB.users.toArray();
            const responseUserId = res.data.personnel_controleur.id;
            const checkExistingUser = usersDataQuery.filter((user) => user.data.personnel_controleur && user.data.personnel_controleur.id === responseUserId);

            if (checkExistingUser.length > 0) {
                DB.users.delete(checkExistingUser[0].id)
            }
            else {
                localStorage.setItem(Constant.localStorageKey.lastUpdate, "0000-00-00 00:00:00")
            }
            const userInfos = res.data;
            const encryptedPassword = aesUtil.encrypt(ApiConfig.AesSecretKey, password);
            await DB.users.add({
                data: userInfos,
                passe: encryptedPassword
            });

            return { isSucess: true, message: "" }
        }

        return { isSucess: false, message: "" }
    } catch (e) {
        throw e
    }
}

export {
    submitForm,
    loginUser,
    updatePdf
}
